export default __webpack_public_path__ + "static/media/Shoes5.34a65f8c.png";